import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import {
    ACHIEVEMENT_DELETED,
    ACHIEVEMENT_DELETING,
    ACHIEVEMENT_DOWNLOADED,
    ACHIEVEMENT_EDITING,
    ACHIEVEMENT_PICTURE_FAILED,
    ACHIEVEMENT_PICTURE_UPLOADING,
    ACHIEVEMENT_UNEARNED_PICTURE_UPLOADING,
    ACHIEVEMENT_POSTING,
    ACHIEVEMENTS_DOWNLOADED,
    ACHIEVEMENTS_FAILED,
    ACHIEVEMENTS_PENDING,
    ACHIEVEMENT_UNEARNED_PICTURE_FAILED,

} from './types';
import { handleError } from '../infos/actions';

const cookies = new Cookies();

export const achievementsPendingAction = () => {
    return {
        type: ACHIEVEMENTS_PENDING,
    };
};
export const achievementPostingAction = () => {
    return {
        type: ACHIEVEMENT_POSTING,
    };
};
export const achievementEditingAction = () => {
    return {
        type: ACHIEVEMENT_EDITING,
    };
};
export const achievementDeletingAction = () => {
    return {
        type: ACHIEVEMENT_DELETING,
    };
};

export const achievementDeletedAction = (achievement) => {
    return {
        type: ACHIEVEMENT_DELETED,
        payload: {
            id: achievement.id,
        },
    };
};

export const AchievementPictureUploadingAction = () => {
    return {
        type: ACHIEVEMENT_PICTURE_UPLOADING,
    };
};

export const AchievementUnearnedPictureUploadingAction = () => {
    return {
        type: ACHIEVEMENT_UNEARNED_PICTURE_UPLOADING,
    };
};

export const achievementDownloadedAction = (achievement, lang) => {
    return {
        type: ACHIEVEMENT_DOWNLOADED,
        payload: {
            achievement: achievement,
            lang: lang,
        },
    };
};

export const achievementsDownloadedAction = (achievements, lang) => {
    return {
        type: ACHIEVEMENTS_DOWNLOADED,
        payload: {
            achievements: achievements,
            lang: lang,
        },
    };
};

export function getAchievements(app, lang) {
    return function (dispatch) {
        dispatch(achievementsPendingAction());
        return APIService
            .getAchievements(app, cookies.get('token'), lang)
            .then(achievements => {
                dispatch(achievementsDownloadedAction(achievements, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
            });
    };
}

export function getAchievement(app, achievementId, lang) {
    return function (dispatch) {
        dispatch(achievementsPendingAction());
        return APIService
            .getAchievements(app, cookies.get('token'), lang)
            .then(achievements => {
                const achievement = achievements.find(a => a.id === achievementId);
                if (!achievement) {
                    throw new Error('Achievement not found');
                }
                dispatch(achievementDownloadedAction(achievement, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
            });
    };
}

export function postAchievement(app, achievement, lang) {
    return function (dispatch) {
        dispatch(achievementPostingAction());
        return APIService
            .postAchievement(app, achievement, cookies.get('token'), lang)
            .then(achievement => {
                dispatch(achievementDownloadedAction(achievement, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
            });
    };
}

export function putAchievement(app, achievement, lang) {
    return function (dispatch) {
        dispatch(achievementEditingAction());
        return APIService
            .putAchievement(app, achievement, cookies.get('token'), lang)
            .then(achievements => {
                dispatch(achievementDownloadedAction(achievements, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
            });
    };
}

export function deleteAchievement(app, achievement, lang) {
    return function (dispatch) {
        dispatch(achievementDeletingAction());
        return APIService
            .deleteAchievement(app, achievement, cookies.get('token'), lang)
            .then(achievements => {
                dispatch(achievementDeletedAction(achievements));
            })
            .catch((error) => {
                dispatch(handleError(error, ACHIEVEMENTS_FAILED));
            });
    };
}

export function postAchievementPicture(app, achievement, picture, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(AchievementPictureUploadingAction());
        return APIService.postAchievementPicture(
            app,
            achievement,
            picture,
            cookies.get('token'),
            lang,
            onUploadProgress,
        ).then(achievement => {
            dispatch(achievementDownloadedAction(achievement, lang));
        }).catch((error) => {
            dispatch(handleError(error, ACHIEVEMENT_PICTURE_FAILED));
        });
    };
}

export function deleteAchievementPicture(app, achievement, lang) {
    return function (dispatch) {
        dispatch(AchievementPictureUploadingAction());
        return APIService.deleteAchievementPicture(
            app,
            achievement,
            cookies.get('token'),
        ).then(achievement => {
            dispatch(achievementDownloadedAction(achievement, lang));
        }).catch((error) => {
            dispatch(handleError(error, ACHIEVEMENT_PICTURE_FAILED));
        });
    };
}

export function postAchievementUnearnedPicture(app, achievement, picture, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(AchievementUnearnedPictureUploadingAction());
        return APIService.postAchievementUnearnedPicture(
            app,
            achievement,
            picture,
            cookies.get('token'),
            lang,
            onUploadProgress,
        ).then(achievement => {
            dispatch(achievementDownloadedAction(achievement, lang));
        }).catch((error) => {
            dispatch(handleError(error, ACHIEVEMENT_UNEARNED_PICTURE_FAILED));
        });
    };
}

export function deleteAchievementUnearnedPicture(app, achievement, lang) {
    return function (dispatch) {
        dispatch(AchievementUnearnedPictureUploadingAction());
        return APIService.deleteAchievementUnearnedPicture(
            app,
            achievement,
            cookies.get('token'),
        ).then(achievement => {
            dispatch(achievementDownloadedAction(achievement, lang));
        }).catch((error) => {
            dispatch(handleError(error, ACHIEVEMENT_UNEARNED_PICTURE_FAILED));
        });
    };
}




// WEBPACK FOOTER //
// src/store/achievements/actions.js